module.exports = __webpack_public_path__ + "static/media/figureSketch.4dcb9883.jpg";